// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"a244bd03","453":"5c30e6e4"}[chunkId] + ".chunk.js";
};